module.exports = __webpack_public_path__ + "img/logo-abc.15e7de0d.png";